// On-screen numeric keypad. Big buttons, designed for tablet landscape.

import { el } from './dom.js';
import { state, notify } from '../state.js';

export function renderKeypad(onSubmit) {
  const display = el('div', { class: 'keypad-display' }, state.inputDigits || ' ');

  function setDigits(d) {
    state.inputDigits = d.slice(0, 20);
    // Update the display directly — no notify() needed since nothing else
    // in the UI depends on inputDigits changing mid-entry.
    display.textContent = state.inputDigits || ' ';
  }

  function tap(label) {
    if (label === '←') {
      setDigits(state.inputDigits.slice(0, -1));
    } else if (label === 'C') {
      setDigits('');
    } else if (label === '✓') {
      if (state.inputDigits.length > 0) onSubmit(state.inputDigits);
    } else {
      setDigits(state.inputDigits + label);
    }
  }

  const grid = el('div', { class: 'keypad-grid' });
  const keys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', 'C', '0', '←'];
  keys.forEach((k) => {
    const isAction = (k === 'C' || k === '←');
    grid.appendChild(el('button', {
      class: 'keypad-key' + (isAction ? ' is-action' : ''),
      onclick: () => tap(k)
    }, k));
  });

  const submit = el('button', {
    class: 'keypad-submit',
    onclick: () => tap('✓')
  }, 'Confirmar');

  return el('div', { class: 'keypad' }, [
    el('div', { class: 'keypad-label' }, 'Ingrese su número de identificación'),
    display,
    grid,
    submit
  ]);
}


